import lang from "@/views/modules/TicketSystems/language/en";

let searchFieldsDef = {
    'ticket_no': {
        label: lang.LBL_TICKET_NUMBER,
    },
    /*'assigned_user_id': {
        label: lang.LBL_REQUEST_TO,
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'ticket_assigned_user_name',
        id: 'ticket_assigned_user_id',
    },*/
    'created_by': {
        label: lang.LBL_REQUEST_BY,
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'ticket_user_name',
        id: 'ticket_created_by',
    },
    'ticket_type': {
        label: lang.LBL_TICKET_TYPE,
        type:'select',
        field_infos:'ticket_type'
    },
    'ed_support': {
        label: lang.LBL_ED_SUPPORT_REQUEST,
        type:'select',
        field_infos:{
            '1':'Yes',
            '0':'No',
        }
    },
    'description': {
        label: lang.LBL_DESCRIPTION,
    },
    'status': {
        label: lang.LBL_TICKET_STATUS,
        type:'select',
        field_infos:'ticket_status'
    },
};
export default { searchFieldsDef }